import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from 'react';
import Typography from '../../Typography';
import { Progress } from './styled';
export const FileProgress = memo(function FileProgress({ progress }) {
    return (_jsxs(_Fragment, { children: [_jsx(Progress, { $progress: progress }), _jsxs(Typography.TextMedium, { children: [progress, '%'] })] }));
});
